import ActionTypes from "../constants/ActionTypes";
import Config from "../constants/Config.js";

const initialState = {
    loading: false,
    error: null,
    tags: {},
};

const tagsCounterReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.FETCH_TAGS_COUNTER_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case ActionTypes.FETCH_TAGS_COUNTER_SUCCESS:
            return {
                ...state,
                loading: false,
                tags: action.tags,
            };
        case ActionTypes.FETCH_TAGS_COUNTER_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        case ActionTypes.SET_TAGS_COUNTER:
            try {
                window.localStorage.setItem(
                    Config.tagsCounterKey,
                    JSON.stringify(action.tags)
                );
            } catch (err) {
                //If user disabled LocalStorage, still save to Store but not to LocalStorage
            }
            return {
                ...state,
                tags: action.tags,
            };
        default:
            return state;
    }
};

export default tagsCounterReducer;
